export class RestoreRecipeRef {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "revision",
            "baseName": "revision",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return RestoreRecipeRef.attributeTypeMap;
    }
    constructor() {
    }
}
